import PropTypes from 'prop-types'
import { Listbox } from '@headlessui/react'
import React from 'react'
import { cn } from '../modules'
import WithAddon from './WithAddon'
import ArrowDownSmall from '../icons/ArrowDownSmall'
import ArrowUpSmall from '../icons/ArrowUpSmall'

function Select({
  label,
  children,
  onChange,
  value,
  placeholder,
  disabled,
  className,
}) {
  return (
    <Listbox value={value} onChange={onChange} disabled={disabled}>
      {({ open }) => (
        <>
          <Listbox.Button
            className={cn(
              'w-full h-10 border-0 border-b-2 cursor-pointer flex items-center outline-0',
              !label && 'text-gray-500',
              open ? 'border-theme-500' : 'border-gray-200 hover:border-gray-300',
              className,
            )}
          >
            <WithAddon
              wrapperClassName="w-full justify-end"
              className="w-full justify-start"
              trailingAddon={open ? <ArrowUpSmall className="text-lg" /> : <ArrowDownSmall className="text-lg" />}
            >
              {label || placeholder}
            </WithAddon>
          </Listbox.Button>
          <div className="relative">
            <Listbox.Options
              className="absolute bg-white w-full border mt-1 pt-2 pb-2 border-gray-50 focus:outline-none shadow-sm
              rounded-md outline-0 left-0 right-0 z-10 max-h-64 overflow-y-auto"
            >
              {children}
            </Listbox.Options>
          </div>
        </>
      )}
    </Listbox>
  )
}

Select.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string, PropTypes.shape({}),
  ]),
  disabled: PropTypes.bool,
  className: cn.propType,
}

Select.defaultProps = {
  placeholder: null,
  label: null,
  onChange: null,
  value: null,
  disabled: false,
  className: null,
}

export default Select
